module.exports = __webpack_public_path__ + "img/quotes-colton-cowell@2x.b524f627.png";